<div class="modal-header glg-modal-header">
  <div class="glg-header-icon">
    <i class="fa-solid fa-font"></i>
  </div>
  <div class="glg-header-body">
    <div class="glg-header-title" translate>Alphabet</div>
    <div class="glg-header-sub">{{ level?.name }}</div>
  </div>
  <button type="button" class="glg-close-btn" (click)="close()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<div class="modal-body glg-modal-body">

  <app-spinner *ngIf="loader"></app-spinner>

  <ng-container *ngIf="!loader">

    <!-- État vide -->
    <div class="glg-empty" *ngIf="!graphemes?.length">
      <div class="glg-empty-icon">
        <i class="fa-solid fa-font"></i>
      </div>
      <div class="glg-empty-text" translate>Aucun graphème disponible actuellement</div>
    </div>

    <ng-container *ngIf="graphemes?.length">

      <div class="glg-toolbar">
        <div class="glg-count-label">
          <i class="fa-solid fa-layer-group"></i>
          {{ graphemes.length }} <span translate>graphèmes</span>
        </div>

        <!-- Bascule hiragana / katakana (japonais uniquement) -->
        <div class="glg-toggle" *ngIf="langTgtSrv.current.code === 'ja'">
          <button type="button" class="glg-toggle-btn" [class.glg-toggle-btn--active]="type === 'hiragana'" (click)="changeType('hiragana')">Hiragana</button>
          <button type="button" class="glg-toggle-btn" [class.glg-toggle-btn--active]="type === 'katakana'" (click)="changeType('katakana')">Katakana</button>
        </div>
      </div>

      <div class="glg-grid">
        <app-grapheme-item
          *ngFor="let grapheme of graphemes; trackBy: trackById"
          [grapheme]="grapheme"
          [type]="type">
        </app-grapheme-item>
      </div>

    </ng-container>

  </ng-container>

</div>
